module.exports = __webpack_public_path__ + "img/hu.48bf8ec9.svg";